import React, { useEffect, useState } from "react";
import { Button, DatePicker, Form, Input, Select, message } from "antd";
import { getProfile } from "../../services/localStorageServices";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaBusinessTime } from "react-icons/fa6";
import { CgBrowser } from "react-icons/cg";
import { FaCircleUser } from "react-icons/fa6";
import { IoMdBusiness } from "react-icons/io";
import { MdLocationOn } from "react-icons/md";
import countriesData from "../Registration/countries.json";
import moment from "moment";
import { post } from "../../apiService";

const ProfileData = () => {
  const { profile } = getProfile();
  const [form] = Form.useForm();
  const { countries } = countriesData;
  const [loading, setLoading] = useState();

  const columns = [
    {
      title: "Name",
      key: "name",
    },
    {
      title: "Phone",
      key: "number",
    },
    {
      title: "Email",
      key: "user_email",
    },
    {
      title: "Gender",
      key: "gender",
    },
    {
      title: "Date Of Birth",
      key: "dob",
    },
    {
      title: "Address One",
      key: "address_one",
    },
    {
      title: "Address Two",
      key: "address_two",
    },

    {
      title: "City",
      key: "city",
    },
    {
      title: "State",
      key: "state",
    },
    {
      title: "Country",
      key: "country",
    },
    {
      title: "Zip Code",
      key: "zip_code",
    },
    {
      title: "Company Name",
      key: "compney_name",
    },
    {
      title: "Website",
      key: "website",
    },
    {
      title: "Business Activity",
      key: "business_activity",
    },
    {
      title: "Business Relationship Period",
      key: "business_relation_ship_period",
    },
    {
      title: "Promoter Name",
      key: "promoter_name",
    },
    {
      title: "Business Registration No",
      key: "business_registration_no",
    },
  ];

  useEffect(() => {
    if (profile?.dob) {
      // Check if the date is valid and not "0000-00-00"
      const dateValue =
        profile.dob === "0000-00-00" ? null : moment(profile.dob);
      form.setFieldsValue({ ...profile, dob: dateValue });
    } else {
      form.resetFields(); // Reset if no profile
    }
  }, [form, profile]);

  const onFinish = async (value) => {
    try {
      setLoading(true);

      let htmlTemplate = `<!DOCTYPE html>
      <html>
      <head>
          <style>
              body {
                  font-family: Arial, sans-serif;
                  margin: 0;
                  padding: 0;
                  background-color: #f9f9f9;
              }
              .email-container {
                  max-width: 600px;
                  margin: 20px auto;
                  background-color: #ffffff;
                  border: 1px solid #dddddd;
                  border-radius: 8px;
                  overflow: hidden;
              }
              .email-header {
                  background-color: #003754;
                  color: #ffffff;
                  text-align: center;
                  padding: 15px;
              }
              .email-header h1 {
                  margin: 0;
                  font-size: 20px;
              }
              .email-body {
                  padding: 20px;
              }
              .email-body p {
                  font-size: 16px;
                  line-height: 1.5;
                  color: #333333;
              }
              .email-body ul {
                  list-style-type: none;
                  padding: 0;
              }
              .email-body ul li {
                  background: #f1f1f1;
                  padding: 10px;
                  margin-bottom: 8px;
                  border-radius: 4px;
                  font-size: 15px;
              }
              .email-footer {
                  text-align: center;
                  padding: 15px;
                  font-size: 14px;
                  color: #777777;
                  background-color: #f1f1f1;
              }
          </style>
      </head>
      <body>
          <div class="email-container">
              <div class="email-header">
                  <h1>Request to Update Profile Details</h1>
              </div>
              <div class="email-body">
                  <p>Dear Sejal Export India,</p>
                  <p>I am writing to request an update to my profile details on your website. Below are my current details:</p>
                  <ul>`;

      Object.entries(value).forEach(([key, val]) => {
        htmlTemplate += ` <li><strong>${
          columns?.find((val) => val.key === key)?.title
        }:</strong> ${
          key === "dob" ? moment(new Date(val)).format("DD-MM-YYYY") : val
        }</li>`;
      });

      htmlTemplate += `</ul>
                  <p>Kindly let me know if any document or proof is required to verify the updated information.</p>
                  <p>Please feel free to contact me if you have any questions or require further clarification.</p>
                  <p>Looking forward to your assistance.</p>
                  <p>Best regards</p>
              </div>
          </div>
      </body>
      </html>`;

      const formData = new FormData();
      formData.append("htmlBody", htmlTemplate);
      formData.append("action", "UpdateEnquiry");

      const resp = await post("/user.php", formData);

      if (resp) {
        setLoading(false);
        message.success("Request Sent, Our team let you if any have any query");
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  return (
    <div className="container mb-5 pb-5">
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <div className="row">
          <div className="col-12">
            <Form.Item label="Name" name="name">
              <Input placeholder="Full Name" prefix={<FaCircleUser />} />
            </Form.Item>
          </div>
          <div className="col-md-6">
            <Form.Item label="Phone" name="number">
              <Input prefix={<FaPhoneAlt />} placeholder="Phone Number" />
            </Form.Item>
          </div>
          <div className="col-md-6">
            <Form.Item label="Email" name="user_email">
              <Input prefix={<MdEmail />} placeholder="Email Id" />
            </Form.Item>
          </div>
          <div className="col-md-6">
            <Form.Item label="Gender" name="gander">
              <Select
                placeholder="Select Gander"
                options={[
                  { label: "Male", value: "Male" },
                  { label: "Female", value: "Female" },
                ]}
              />
            </Form.Item>
          </div>
          <div className="col-md-6">
            <Form.Item label="Date Of Birth" name="dob">
              <DatePicker className="w-100" />
            </Form.Item>
          </div>
          {form.getFieldValue("compney_name") !== undefined &&
            form.getFieldValue("compney_name") !== "undefined" &&
            form.getFieldValue("compney_name") !== "null" &&
            form.getFieldValue("compney_name") !== null && (
              <div className="col-md-6">
                <Form.Item label="Company Name" name="compney_name">
                  <Input
                    prefix={<FaBusinessTime />}
                    placeholder="Comapny Name"
                  />
                </Form.Item>
              </div>
            )}
          {form.getFieldValue("website") !== undefined &&
            form.getFieldValue("website") !== "undefined" &&
            form.getFieldValue("website") !== "null" &&
            form.getFieldValue("website") !== null && (
              <div className="col-md-6">
                <Form.Item label="Website" name="website">
                  <Input placeholder="Website URL" prefix={<CgBrowser />} />
                </Form.Item>
              </div>
            )}
          <div className="col-md-6">
            <Form.Item
              label="Nature Of Business Activity"
              name="business_activity"
            >
              <Select
                options={[
                  { label: "Jeweler", value: "Jeweler" },
                  { label: "Diamond Broker", value: "Diamond Broker" },
                  { label: "Individual", value: "Individual" },
                ]}
              />
            </Form.Item>
          </div>
          {form.getFieldValue("business_relation_ship_period") !== undefined &&
            form.getFieldValue("business_relation_ship_period") !==
              "undefined" &&
            form.getFieldValue("business_relation_ship_period") !== "null" &&
            form.getFieldValue("business_relation_ship_period") !== null && (
              <div className="col-md-6">
                <Form.Item
                  label="Business Relationship Period"
                  name="business_relation_ship_period"
                >
                  <Input
                    prefix={<IoMdBusiness />}
                    placeholder="Business Relationship Period"
                  />
                </Form.Item>
              </div>
            )}
          {form.getFieldValue("promoter_name") !== undefined &&
            form.getFieldValue("promoter_name") !== "undefined" &&
            form.getFieldValue("promoter_name") !== "null" &&
            form.getFieldValue("promoter_name") !== null && (
              <div className="col-md-6">
                <Form.Item
                  label="Name Of Promoter / Partner / Director"
                  name="promoter_name"
                >
                  <Input
                    prefix={<IoMdBusiness />}
                    placeholder="Name Of Promoter / Partner / Director"
                  />
                </Form.Item>
              </div>
            )}
          {form.getFieldValue("business_registrarion_no") !== undefined &&
            form.getFieldValue("business_registrarion_no") !== "undefined" &&
            form.getFieldValue("business_registrarion_no") !== "null" &&
            form.getFieldValue("business_registrarion_no") !== null && (
              <div className="col-md-6">
                <Form.Item
                  label="Business Registration No"
                  name="business_registrarion_no"
                >
                  <Input
                    prefix={<IoMdBusiness />}
                    placeholder="Business Registration No"
                  />
                </Form.Item>
              </div>
            )}
          <div className="col-md-6">
            <Form.Item label="Country" name="country">
              <Select
                showSearch
                placeholder="Select The Country"
                className="registration-antd-input-tag"
                name="country"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {countries?.map((country, index) => (
                  <Select.Option key={index} value={country}>
                    {country}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          <div className="col-md-6">
            <Form.Item label="Address One Line 1" name="address_one">
              <Input prefix={<MdLocationOn />} placeholder="Address Line 1" />
            </Form.Item>
          </div>
          <div className="col-md-6">
            <Form.Item label="Address Two Line 2" name="address_two">
              <Input prefix={<MdLocationOn />} placeholder="Address Line 2" />
            </Form.Item>
          </div>
          <div className="col-md-4">
            <Form.Item label="City" name="city">
              <Input prefix={<MdLocationOn />} placeholder="City" />
            </Form.Item>
          </div>
          <div className="col-md-4">
            <Form.Item label="State" name="state">
              <Input prefix={<MdLocationOn />} placeholder="State" />
            </Form.Item>
          </div>
          <div className="col-md-4">
            <Form.Item label="Zip Code" name="zip_code">
              <Input prefix={<MdLocationOn />} placeholder="Zip Code" />
            </Form.Item>
          </div>
          <div className="col-12 mt-4">
            <Button htmlType="submit" loading={loading} className="bg-success text-white">
              Send Update Request
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default ProfileData;
